import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';
import { OfferKind, OfferStatus } from '@recruitee/offers-types';
import type { TalentPoolBrief } from '@recruitee/talent-pools-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TalentPoolBrief>()(
  'TalentPoolsNewBrief',
  {
    customActions: adapter => ({
      references: (state, payload: { data: TalentPoolBrief[] }) => {
        const entities = payload.data.map(entity => ({
          ...entity,
          kind: OfferKind.TalentPool,
        }));
        return adapter.updateOrCreateMany(state, entities);
      },
    }),
  },
);

const TalentPoolsNewBriefSelectors = {
  ...selectors,
  default: memoizeSelector(() =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => entity.status === OfferStatus.Draft),
    ),
  ),
  archived: memoizeSelector(() =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => entity.status === OfferStatus.Archived),
    ),
  ),
};

export {
  TalentPoolsNewBriefSelectors,
  actions as TalentPoolsNewBriefActions,
  reducer as TalentPoolsBriefReducer,
  namespace as TalentPoolsBriefNamespace,
};
